// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import CONSTANTS from '../constants/telemetry';
import { EnvironmentType, IEnvironment } from './environmentType';

/**
 * Local environment, used for localhost debugging
 * */
export class LocalEnvironment {
    static getConfiguration(): IEnvironment {
        return {
            aadClientIdForWebUser: '70039c9c-eb42-452c-bcdc-5aa65d164562',
            deployed: false,
            developerTelemetryKey: '3fe74288-4274-4832-aa42-f0f89d9020d1',
            environmentType: EnvironmentType.LocalHost,
            hostname: `${window.location.origin}`,
            name: 'LOCAL',
            oldRoboBaseUrl: 'https://robouat.microsoft.com',
            production: false,
            telemetryKey: '934466e2-8117-42e2-b20a-3b1798995b88',
            telemetryUrl: CONSTANTS.telemetryUrl,
            isAutoUserOnboarding: true,
            graphApiDirectoryUrl: 'https://graph.microsoft.com/v1.0/directoryObjects',
            jarvisEmailCheck: true,
        };
    }
}
